import { cn } from '@Utils/cn';

/**
 * Classic three-dot "typing" indicator with a staggered wave — shown while an assistant
 * message is waiting to respond / analyzing. Each dot shares one bounce animation, offset
 * by negative delays so they ripple in sequence.
 */
export default function TypingDots({ className }: { className?: string }) {
  return (
    <span
      role="status"
      aria-label="Assistant is responding"
      className={cn('inline-flex items-center gap-1 py-1', className)}
    >
      <span className="size-1.5 animate-bounce rounded-full bg-zinc-400 [animation-delay:-0.3s]" />
      <span className="size-1.5 animate-bounce rounded-full bg-zinc-400 [animation-delay:-0.15s]" />
      <span className="size-1.5 animate-bounce rounded-full bg-zinc-400" />
    </span>
  );
}
